import { render, staticRenderFns } from "./CreateSchoolWizard.vue?vue&type=template&id=29088eea&"
import script from "./CreateSchoolWizard.vue?vue&type=script&lang=js&"
export * from "./CreateSchoolWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports